<template>
  <span v-html="html"></span>
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: "span",
    },
    className: {
      type: String,
      required: true,
    },

    keyword: {
      type: String,
      required: true,
    },

    text: {
      type: String,
      required: true,
    },
  },

  computed: {
    html() {
      const { tag, className, keyword, text } = this;
      const regRaw = `(${keyword})`;
      const reg = new RegExp(regRaw, "gi");
      const html =
        keyword && text.match(reg)
          ? text.replace(reg, `<${tag} class=\"${className}\">$1</${tag}>`)
          : text;

      return html;
    },
  },
};
</script>
